// eslint-disable-next-line @rushstack/typedef-var -- disable scoped to legacy integration boundary in this file
export const translation = {
    common: {
        cancel: 'Cancel',
        delete: 'Delete',
        finished: 'Finished',
        yesContinue: 'Yes, continue',
        loading: 'Loading',
        settings: 'Settings',
        save: 'Save',
        remove: 'Remove',
        ok: 'Ok',
        error: 'Unknown Error',
        yesRemove: 'Yes, remove',
        language: 'Language',
        appearance: 'Appearance',
        themeSystem: 'System',
        themeLight: 'Light',
        themeDark: 'Dark',
        beta: 'Beta',
        themeDarkBetaHint: 'Dark mode is still in beta and may contain minor visual imperfections.',
        back: 'Back',
        errorValidation: 'Validation failed',
        history: 'History',
        description: 'Description',
        action: 'Action',
        system: 'System',
        apiUser: 'API User',
        unknownUser: 'Unknown User',
        brand: 'Brand',
        tableOfContentsText: 'Table of Contents Text',
        confirm: 'Confirm',
    },
    historyEntryDescriptions: {
        historyPostImportDisclaimer: 'The information about status changes in the “Description” column (e.g., “Draft” > “Publish”) in the history tab for this article may be incomplete. This affects entries from July 5 to July 10 2025',
        authorMerged: 'Author merged',
        scheduledChangeApplied: 'Scheduled change applied',
        scheduledChangeCreated: 'Scheduled change created',
        scheduledChangeUpdated: 'Scheduled change updated',
        scheduledChangeDeleted: 'Scheduled change deleted',
        createDate: 'Initial Creation Date: {date}',
        firstPublishedDate: 'First Published Date: {date}',
        abTestStarted: 'A/B headline test started',
        abTestStoppedByEditor: 'A/B headline test stopped',
        abTestCompleted: 'A/B headline test completed',
        abTestCompletedNoWinner: 'A/B headline test completed - no winner',
        abTestStartFailed: 'The A/B headline test could not be started. It will be retried automatically.',
        abTestPollFailed: 'The A/B headline test result could not be retrieved. It will be retried automatically.',
    },
    router: {
        createImage: 'Upload Image',
        editImage: 'Edit Image',
        createPerson: 'Create Person',
        editPerson: 'Edit Person',
        createGallery: 'Create Gallery',
        editGallery: 'Edit Gallery',
        createPage: 'Create Page',
        editPage: 'Edit Page',
        createRedirect: 'Create Redirect',
        editRedirect: 'Edit Redirect',
        createToplink: 'Create Toplink',
        editToplink: 'Edit Toplink',
        createCustomer: 'Create Customer',
        editCustomer: 'Edit Customer',
        whitelist: 'Whitelisted domains',
        createWhiteListLink: 'Create Whitelist link',
    },
    navigation: {
        hello: 'Hello',
        logout: 'Logout',
        minimize: 'Minimize',
        articles: 'Articles',
        channels: 'Channels',
        channelizer: 'Channelizers',
        images: 'Images',
        galleries: 'Galleries',
        videos: 'Videos',
        people: 'People',
        authors: 'Authors',
        users: 'Users',
        additiveRights: 'Additive Rights',
        pages: 'Pages',
        staticPages: 'Static pages',
        whiteList: 'Whitelisted domains',
        userManagement: 'User management',
        homeAndChannels: 'Home & channel pages',
        noPermission: 'You have no access to this page.',
        authorProfile: 'Author profile',
        listArticles: 'Lists',
        linkoutTeasers: 'Linkout Teasers',
        menuTree: 'Menu tree',
        tools: 'Tools',
        authorMerge: 'Merge authors',
        bfJobGroups: 'Teams',
        seoWhiteList: 'Whitelisted domains',
        linksBox: 'Partner linkboxes',
        apiTeaser: 'API teasers',
        apiUsers: 'API Users',
        testreportGenerator: 'Testreport generator',
        permissions: {
            viewOnly: {
                label: 'View only',
                hover: 'You cannot add, change or remove any item.',
            },
        },
        moduleExamples: {
            _title: 'Module examples',
            complexModule: 'Complex Module',
            complexPage: 'Complex page',
            externalTool: 'External tools',
        },
        externalContent: {
            _title: 'External contents',
            partnerContent: 'Partners',
            agencyContent: 'Agencies',
            expertsContent: 'Experts',
        },
        partnerManagement: {
            _title: 'Partner management',
        },
        assemblerCategories: 'Partner categories',
        assemblerFeeds: 'Partner feeds',
        partners: 'Partners',
        catTool: 'CAT tool',
        aissist: 'AISSIST',
        widgets: {
            _title: 'Widgets',
        },
        articlesBox: 'Internal linkboxes',
        articlePush: 'Pushes',
        ctaButton: 'CTA buttons',
        inpageWidget: 'External code widgets',
        tags: 'Tags',
        hubPages: 'Hub pages',
        tagEntities: 'Entities',
        reusableText: 'Textboxes',
        redirect: 'Redirects',
        newsletterWidgets: 'Newsletter widgets',
        recipe: 'Recipes',
        videoPage: 'Video pages',
        finanzen100ChartWidgets: 'Stock chart widgets',
        abHeadlineTest: 'A/B headline tests',
        profile: 'Profile',
        reportProblem: 'Report problem',
        movies: 'Movies',
    },
    login: {
        login: 'Login',
        pwLostTitle: 'Forgot your Password?',
        pwLostText: 'No Worries! Just enter your Email Address and we will send you a mail with all necessary steps to create a new one.',
        fieldEmail: 'Email',
        fieldPassword: 'Password',
        twoFactorToken: '2 Faktor Token',
        alreadyAccountText: "You don't have an account yet?",
        alreadyAccountLink: 'Request now.',
        sendEmail: 'Send Email',
        backToLogin: 'Back to Login',
        instructionsSent: 'Instructions sent',
        checkEmail: 'Please check your email inbox to reset your password',
        sessionExpired: 'Session expired. Please log in again.',
        mailtoAccountSubject: 'Access to BurdaForward-Editor',
        wrongEmail: 'Email and password are not correct',
        wrongToken: 'Token is not correct',
        mailtoAccountBody: 'Dear Editor-Team,%0D%0AI have just joined BurdaForward and need access to the editor. My email is: &lt;insert email&gt;.%0D%0ABest regards',
    },
    articleApi: {
        pathExists: 'Article with this path (SEO title) already exists',
        notFound: 'Article not found',
        updated: 'Article updated',
        created: 'Article created',
        outdated: 'Article data is outdated. Could not update.',
    },
    articles: {
        backToList: 'Back to Article list',
        settings: 'Settings',
        content: 'Content',
        preview: 'Preview',
        basics: 'Basics',
        saveKeepPublished: 'Save & Keep Published',
        savePublish: 'Publish',
        saveScheduled: 'Schedule publication',
        saveOffline: 'Take offline',
        saveDraft: 'Save as Draft',
        deleteArticle: 'Delete Article',
        messagePublishTitle: 'Publish Article',
        messagePublish: 'Are you sure you want to publish this article?',
        messageUnpublishTitle: 'Take article offline',
        invalidOperation: 'Invalid operation',
        backToArticle: 'Back to article',
        messageAutoImageTitle: 'Automatically import images',
        messageAutoImage: 'Do you want to import the teaser image and other images automatically?',
        messageAutoImageConfirm: 'Yes, import',
        messageAutoImageCancel: 'No',
        messageDeleteArticleTitle: 'Delete Article',
        messageDeleteArticle: 'Are you sure you want to delete this article?',
        messageConfirmUnpublishArticle1: 'Are you sure you want to take article',
        messageConfirmUnpublishArticle2: 'offline?',
        messageConfirmDraftArticle2: 'set as draft?',
        errorPreventSaveAsDraft: 'You cant save an article as draft if a publish date is set. Please check the box "Publish date" or click "Save & Publish".',
        errorMandatoryFields: "Sorry, you can't save this article because it's missing mandatory information",
        errorAMPValidation1: 'Article',
        errorAMPValidation2: 'was updated but the AMP validation failed',
        messageArticleDeleted: 'Article deleted',
        modeUnpublished: 'Article offline',
        modeScheduled: 'Publishing date scheduled',
        modePublished: 'Published',
        modeDraft: 'Draft',
        removeArticle: 'Show Article',
        versions: 'Versions',
    },
    articlesSettings: {
        leadText: 'Lead Text',
        peopleInArticle: 'People within Article',
        backgroundArticles: 'Background Articles',
        adArticle: 'Mark as ad',
        adsEnabled: 'Ads enabled',
        hideFromNewsticker: 'Hide from newsticker',
        hideFromTeaserList: 'Hide from most recent',
        ampEnabled: 'AMP enabled',
        checkValidation: 'Check validation',
        msn: 'MSN Service',
        magazine: 'Content from BUNTE-Magazin',
        adTags: 'Ad tags',
        weight: 'Weight',
        showPartnerLogo: 'Show partner logo',
        isBought: 'Article bought',
        seoUrlSettings: 'URL & SEO',
        canonicalUrl: 'Canonical URL',
        unknownCanonicalUrl: 'Unknown - Will be refreshed when published',
        missingCanonicalUrl: 'Missing - Please contact CTF if the problems persists',
        noIndex: 'Activate NoIndex',
        toArticle: 'To Article',
        author: 'Author',
        createdBy: 'Created by',
        messageAMPSuccess: 'AMP validation was successful',
        messageAMPFailed: 'AMP validation failed',
        messageAMPFailedMandatory: 'AMP validation failed because not all mandatory fields are filled',
        messagePreviewTitle: 'Article not saved',
        messagePreview: 'You need to save the article before you can preview it.',
        messagePreviewCancel: 'Ok',
        messageNotSavedTitle: 'Unsaved changes',
        messageNotSaved: 'You need to save before you can open the article and display the changes.',
        messageNotSavedCancel: 'Back to editor',
        messageNotSavedButton: 'Open anyway',
        bfJobTitle: 'Job team',
        source: 'Source',
        showMostReadArticles: 'Show the most read articles block',
        general: 'General',
        originalSourceUrl: 'Curated URL',
    },
    articlesList: {
        title: 'Article',
        newButton: 'New Article',
        multiLabel: 'Save selected Articles',
        search: 'Search by kicker or title',
        myArticles: 'My articles',
        includeSubchannels: 'Include subchannels',
        statusDropdown: 'Status',
        statusAll: 'All',
        statusDraft: 'Draft',
        statusSchedule: 'Schedule',
        statusPublished: 'Published',
        statusUnpublish: 'Offline',
        typeDropdown: 'Article type',
        typeAll: 'All',
        typeImages: 'Images',
        typeVideos: 'Videos',
        typeGalleries: 'Galleries',
        displayDateFrom: 'Show from',
        displayDateTo: 'Show to',
        displayPeriod: 'Period',
        isPremium: 'Only Inside articles',
        isBought: 'Article bought',
        contentPartner: 'Content Partner',
        loading: 'Loading Articles',
        deleteArticle: 'Delete Article',
        headerStatus: 'Status',
        headerKickerTitle: 'Kicker, Title',
        headerChannel: 'Channel',
        headerPublished: 'Published at',
        headerChanged: 'Changed at',
        headerAMP: 'AMP',
        headerAMPDescription: 'Green tick: The AMP version of the article is valid. It works on all Google platforms.\nRed Cross: The article contains elements that invalidate the AMP. Please check again.',
        multiSelect: 'Select',
        dpEdit: 'Edit',
        dpGoToArticle: 'Go to Article',
        dpDelete: 'Delete Article',
        messageNoSelfLink: "Article can't link to itself.",
        messageDelete1: 'Are you sure you want to delete article',
        messageDelete2: '?',
        messageDeleteSuccess: 'Article deleted',
        openInNewTab: 'Open in new tab',
        isRenderedByCTF: 'Rendered by CTF',
        hasBeenModifiedInCTF: 'Modified in Vibe',
        isEditableInCTF: 'Editable in Vibe',
    },
    articlesEdit: {
        kicker: 'Kicker',
        title: 'Title',
        people: 'People',
        leadText: 'Lead Text',
        words: 'Words',
        chars: 'Characters',
        addContent: 'Add content',
        remove: 'remove',
        externalSource: 'External source',
        excludedSources: 'Excluded external sources',
        channel: 'Channel',
        articleTitle: 'Article Title',
        seoTitle: 'SEO Title',
        articleType: 'Article Type',
        image: 'Image',
        video: 'Video',
        gallery: 'Gallery',
        imageSelector: 'Select or upload main image',
        videoSelector: 'Select main video',
        mainImageTitle: 'Main image',
        teaserVideoTitle: 'Preview image',
        teaserImageTitle: 'Teaser image',
        mainImageTitleTooltip: 'The main image is displayed on the article page.',
        mainVideoTitleTooltip: 'The main video is displayed on the article page.',
        teaserVideoTitleTooltip: 'The preview image is displayed on the article page.',
        differentTeaser: 'Different teaser and A/B headline test',
        differentTeaserTooltip: 'Different teaser (kicker, title, lead text) for home and channel pages or short title for space-saving UI elements',
        teaserImageTitleTooltip: 'The teaser image is displayed on channel pages. If there is no teaser image placed, the main image is  displayed on channel pages.',
        teaserImageSelector: 'Select or upload teaser image',
        teaserInfo: 'If no teaser image exists the main image will be used on channel pages',
        teaserInfoVideo: 'If no teaser image exists the video image will be used on channel pages',
        setAsDefault: 'Set as Article text',
        articleTab: 'Article',
        teaserTab: 'Teaser',
        shortTitleTab: 'Short title',
        shortTitle: 'Short title',
        shortTitleHelper: 'Optional shorter title for use in space-restricted UI elements.',
        gallerySelector: 'Gallery image',
        teaserGalleryTitle: 'Teaser image',
        teaserGalleryMainImageTitle: 'Main Image',
        teaserGalleryMainImageLabel: 'Select or upload the main image',
        teaserGalleryMainImageCheckbox: 'Add to gallery',
        teaserGalleryMainImageCheckboxTooltip: 'The main image will be added to the selected gallery.',
        gallerySelectorTooltip: 'The gallery image is displayed on the article page.',
        teaserGalleryMainImageTitleTooltip: 'The main image is optional.',
        teaserImageGallery: 'Select or upload teaser image',
        dateSettingsTitle: 'Publishing settings',
        showFirstPublishDate: 'Show first publish date',
        videoAutoplay: 'Autoplay',
        videoSpotted: 'Spotted video',
        videoSpottedTooltip: 'Select "spotted video" for video first articles where the video is main content. The content will be marked as "Video" in the teaser. If the option “spotted video” is deactivated, it is a performance video which will be marked as text "Mit Video" in the teaser.',
        articleDisplayDate: 'Shown date',
        noPublishDate: 'Publish date',
        setPublishDate: 'Publish at',
        setUnpublishDate: 'Take offline at',
        relatedDeleted: 'Deleted',
        relatedExpired: 'Expired',
        relatedWeight: 'Weight',
        relatedRemove: 'Remove',
        relatedPlaceHere: 'Place articles here',
        relatedPrioAd: 'AD',
        relatedPrioInside: 'LOGIN',
        relatedArticleAdd: 'Link article',
        seoPerfect: 'Perfect Length',
        seoOkay: 'Okay, shorten if possible',
        seoLong: 'Too long, please shorten!',
        desktopAlertTitle: 'An error has occurred',
        desktopAlertDescription: 'Your resolution is currently too low to display the desktop preview.<br/>Please minimize the menu on the left to display the desktop preview.',
        addPeople: 'Add People',
    },
    articleBlocks: {
        ctaLayout: 'Layout',
        ctaButton: 'Button',
        ctaStickyButton: 'Sticky Button',
        ctaBox11: 'Box 1:1',
        ctaBox11Info: 'Box with Image in 1:1 Format',
        ctaBox169: 'Box 16:9',
        ctaBox169Info: 'Box with Image in 16:9 Format',
        ctaTitle: 'Title',
        ctaButtonText: 'Button Text (17 character limit)',
        ctaLink: 'Button Link',
        ctaIsAffiliate: 'Show affiliate disclaimer',
        noFollow: 'No Follow',
        noFollowTooltip: "The link will be labeled as 'nofollow'. Please always select nofollow for commercial links.",
        blockTeaser: 'Article Teaser',
        imageUrl: 'Image URL',
        imagePlaceholder: 'Link URL, must start with https://',
        videoPlaceholder: 'Select Video',
        videoTeaser: 'Video Teaser',
        hasAffiliate: 'Affiliate Link',
        hasAffiliateTooltip: 'If a link is labeled as an affiliate link, the affiliate disclaimer box will appear at the top of the article and the element will be marked as an advertisement.',
        newTab: 'Open in new tab',
        bound: 'Bound',
        boundTooltip: 'By default the Banner appears standalone and not bound to the subsequent Stage.',
        loginwallText: "Customers can register here to see more content. Logged in users don't see this element.",
        quoteAuthor: 'Quote from',
        scriptBlock: 'Insert custom JavaScript (will NOT be shown in AMP). Please be aware of the GDPR issues when used.',
        rawBlock: 'Insert custom JavaScript (shown on AMP). Please be aware of the GDPR issues when used.',
        becomeInsider: 'Become an INSIDER and continue reading',
        highlightBox: 'Highlight Box',
        labelText: 'Text',
        labelImage: 'Image',
        labelGallery: 'Gallery',
        labelVideo: 'Video',
        labelArticle: 'Article',
        labelPaywall: 'Paywall',
        labelLoginwall: 'Login',
        labelSocial: 'Social',
        labelQuote: 'Quote',
        labelCTA: 'Call to action',
        labelNewsletter: 'Newsletter Box',
        or: 'OR',
        imageLink: 'Alternatively add image via image link',
        imageUrlStart: 'Image Url, must start with https://',
        imagePreview: 'Vorschau',
    },
    articlesVersions: {
        noVersions: 'No versions available',
        unknownEditor: 'Editor unknown',
        modifiedBy: 'Modified by',
        modifiedAt: 'Modified at',
    },
    authorsApi: {
        createAlreadyExists: "Can't create author because another author with this name already exists",
        updateAlreadyExists: "Can't update author because another author with this name already exists",
        created: 'Author created',
        updated: 'Author updated',
        notFound: 'Author not found',
    },
    authorsList: {
        title: 'Authors',
        newButton: 'New Author',
        name: 'Search by name',
        status: 'Status',
        statusActive: 'Active',
        statusInactive: 'Inactive',
        loading: 'Loading authors',
        headerStatus: 'States',
        headerName: 'Display name',
        headerCreatedAt: 'Created at',
        messageActive: 'Author active',
        messageInactive: 'Author blocked',
        dpEdit: 'Edit',
        disableAllBrands: 'Disable all brands',
        activateAllBrands: 'Activate all brands',
    },
    authors: {
        backButton: 'Back to authors list',
        displayName: 'Display name',
        jobTitle: 'Job title',
        biography: 'Biography',
        xing: 'Xing URL',
        linkedin: 'LinkedIn URL',
        twitter: 'Twitter URL',
        facebook: 'Facebook URL',
        instagram: 'Instagram URL',
        tiktok: 'Tiktok URL',
        email: 'Email',
        settings: 'Settings',
        active: 'Active',
        showArticles: 'Show articles',
        vgWort: 'VG-Wort Author number',
        profileUrl: 'Author profile URL',
        path: 'Path',
        pathPlaceholder: 'Will be automatically filled',
        toAuthorProfile: 'To authors profile',
        messageMandatoryInfo: "You can't save the author yet because mandatory information is missing.",
        messageUpdated: 'Author updated',
        messageCopy: 'Path copied to clipboard',
        messageCreated: 'Author created',
        createdAssigned: 'Autor created and assigned to user',
    },
    channelsApi: {
        notFound: 'Channel not found',
        created: 'Channel created',
        pathExists: 'Channel with this path already exists',
        outdated: 'Channel data is outdated. Update failed.',
        updated: 'Channel updated',
        pathEmpty: "Path can't be empty",
    },
    channels: {
        basics: 'Basics',
        backButton: 'Back',
        settings: 'Create Channel',
        settingsLabel: 'Settings',
        config: 'Configuration',
        messageNotSelf: "The parent channel can't be this channel",
        messageMandatoryInfo: "You can't save this channel because it is missing mandatory information",
        messageMandatoryInfoConfig: "You can't save this channel because the channel configuration is missing mandatory information",
        messageCreated: 'Channel created',
        messageUpdated: 'Channel updated',
        name: 'Channel Name',
        parentChannel: 'Parent Channel',
        seoTitle: 'SEO Title',
        seoDescription: 'SEO Description',
        adTags: 'Ad Tags',
        markAsAd: 'Mark as advertisement',
        adsEnabled: 'Ads enabled',
        defaultConfig: 'Use standard channel configuration',
        goToChannel: 'To channel',
    },
    channelsList: {
        title: 'Channel',
        newButton: 'New Channel',
        search: 'Search by channel name',
        searchByBrand: 'Search by brand',
        brand: 'Brand',
        loading: 'Loading Channels',
        headerTitle: 'Title',
        headerBreadcrumb: 'Breadcrumb',
        edit: 'Edit',
        view: 'Show',
        mainChannel: 'Main channel',
        childChannel: 'Sub channel',
        tooltip: 'Teasers and links can be freely defined here to link other elements instead of articles. Promotional offers should be marked with the label "Advertisement".',
    },
    channelConfigApi: {
        created: 'Channel configuration created',
        outdated: 'Channel configuration is outdated. Update failed',
        updated: 'Channel configuration updated ',
        notFound: 'Channel configuration not found',
    },
    channelConfig: {
        title: 'Channel Title',
    },
    channelBlock: {
        messageNoNewBlocks: "You can't add new blocks here anymore",
        addContent: 'Add element',
    },
    channelBlocks: {
        channel: 'Channel',
        premiumOnly: 'Inside only',
        excludedContent: 'Excluded content',
        excludedChannels: 'Excluded channels',
        excludedWeights: 'Excluded weights',
        stageLayout: 'Stage layout',
        standardLayout: 'Standard',
        standardLayoutGrid: 'Standard Grid',
        headlineOneColumnLayout: 'Headline One Column',
        headlineOnlyLayout: 'Headline Only',
        newstickerLayout: 'Newsticker',
        low: 'low',
        medium: 'medium',
        high: 'high',
        showExceptions: 'Show exceptions',
        hideExceptions: 'Hide exceptions',
        messageNotEmptyFixed: "Fixed article can't be empty",
        selectArticle: 'Select article',
        singleGallery: 'Single gallery',
        dayGallery: 'Gallery of the day',
        title: 'Title',
        kicker: 'Kicker',
        link: 'Link',
        label: 'Label',
        leadText: 'Lead Text',
        selectImage: 'Select or upload image',
        subChannelTags: 'Subchannel tags',
        listSize: 'Size of article list',
        excludedSubchannels: 'Excluded Subchannels',
        showPreview: 'Show preview',
        hidePreview: 'Hide preview',
        newstickerText: 'The newsticker always shows the three latest articles.',
        loginwallText: "Customers can register here to see more content. Logged in users don't see this element.",
        channelTags: 'Channel tags',
        teaserTextStandard: 'Two to six teasers. One main teaser, the rest below.',
        teaserStandard: 'Standard',
        teaserTextTwoCol: 'Exactly five teasers. One main teaser, the rest below in two columns.',
        teaserTwoCol: 'Two columns',
        bInside: 'Bunte Inside',
        duplicatePlacements: 'Duplicate placement settings',
        duplicatePlacementsMsg: 'The placements are aleady filled.',
        duplicatePlacementsMsg2: 'Please delete a placement to duplicate the placement settings.',
        messageDuplicateContent: 'There is duplicate content within the channel configuration',
        messageNotFiveArticles: 'There must be exactly five articles in the two column layout',
        messageMinimumArticleCount: 'There must be at least two articles in a channel',
        topbarText: 'Articles with the highest priority are selected in Pilot > Home & Top Bar and displayed in the "Meistgelesen" stage.',
        performanceOffset: 'Performance offset in hours',
        messageVideoCount: 'Video blocks must contain three or six videos',
        messageUniqueContent: 'There is duplicate content within this block',
        messageValidateOffset: 'Performance offset needs to be a value between 0 and 10',
        mainStageText: 'Newest articles with high priority are selected in Pilot > Home & Top Bar and displayed on the main stage.',
        personlookText: 'This is the person look. It is filled externally by tracdelight.',
    },
    cmsUsersApi: {
        emailExists: 'User with this email address already exists',
        emailNotFound: 'Email address not found',
        updated: 'User updated',
        created: 'User created',
        notFound: 'User not found',
        wrongEmail1: 'Wrong email or password (Error code 1)',
        wrongEmail2: 'Wrong email or password (Error code 2)',
        accountInvalid: 'Your account is invalid. Please contact an administrator.',
        passwordMissing: 'Please set the password first. Check your email inbox for further instructions',
        verficationFailed1: '2 factor authentication failed (Error code 1)',
        verficationFailed2: '2 factor authentication failed (Error code 2)',
        tooManyLogins: 'Too many login attempts. Locked for one hour',
        tooManyMFATrials: 'Too many reset attempts. Locked for one hour',
        sessionInvalid: 'Session invalid',
        sessionDeleted: 'Session deleted',
        tokenExpired: 'Token expired',
        resetPasswortEmailSent: 'Password reset email sent',
        passwordInvalid: 'Password invalid',
        messageUserActivated: 'User reactivated',
        messageUserBlocked: 'User blocked',
    },
    cmsUsers: {
        backButton: 'Back to users list',
        name: 'Name',
        resetPW: 'Reset password',
        resetPWInfo: 'We will send a mail with information about resetting the password to the user',
        reset2FA: 'Reset 2-FA and password',
        reset2FAInfo: 'We will sent a mail with information about resetting the password and the two factor authentication to the user',
        saveAndCreate: 'Save & create Author',
        active: 'Active',
        messageMandatoryInformation: "You can't save because mandatory information is missing",
        messageUpdated: 'User updated',
        messageCreated: 'User created',
    },
    cmsUsersList: {
        title: 'Users',
        newButton: 'New User',
        search: 'Search by name or email',
        status: 'Status',
        dpActive: 'Active',
        dpInactive: 'Blocked',
        loading: 'Loading CMS users',
        headerStatus: 'Status',
        headerName: 'Name',
        headerEmail: 'Email',
        headerCreatedAt: 'Created at',
        headerLastLogin: 'Last login',
        dpEdit: 'Edit',
        dpBlock: 'Block',
    },
    contentSharing: {
        title: 'Contentsharing',
        search: 'Search',
        showAll: 'Show all',
        loading: 'Loading articles',
        disclaimer: 'Please check that you hold the required rights and permissions prior to importing content',
        headerKickerTitle: 'Kicker, Title',
        headerSource: 'Source',
        headerDisplayDate: 'Display date',
        dpSelect: 'Select',
        openInNewTab: 'Open in new tab',
    },
    galleriesApi: {
        notFound: 'Gallery not found',
        updated: 'Gallery updated',
        created: 'Gallery created',
    },
    galleries: {
        backButton: 'Back to gallery list',
        kicker: 'Kicker',
        title: 'Title',
        saveKeepPublished: 'Save & Keep published',
        savePublish: 'Save & Publish',
        saveOffline: 'Save & take offline',
        saveDraft: 'Save as draft',
        settings: 'Settings',
        adsActive: 'Ads enabled',
        dayGallery: 'Gallery of the day',
        publishDate: 'Publish date',
        expirationDate: 'Expiration date',
        messageSaveGallery: 'Save gallery',
        messageCancel: 'No, stay',
        messageYesPublish: 'Yes, publish',
        messageYesOffline: 'Yes, take offline',
        messageGalleryDay1: 'Gallery',
        messageGalleryDay2: 'This gallery will be set as Gallery of the day. Previous Gallery of the day will be unset.',
        messageGalleryDay3: 'This gallery will be unset as Gallery of the day. There will be no Gallery of the day.',
        messageMandatoryInfo: "You can't save the gallery because it is missing mandatory information",
        messageUpdated: 'Gallery updated',
        messageCreated: 'Gallery created',
        imageSelectorTitle: 'Images and articles',
        relatedGalleriesSelectorTitle: 'Related galleries',
        preventDayGallery: 'Only galleries that are published can be set as Gallery of the day',
    },
    relatedGalleries: {
        addNew: 'Link gallery',
    },
    galleriesList: {
        title: 'Galleries',
        newButton: 'New gallery',
        searchTitleKicker: 'Search by title or kicker',
        status: 'Status',
        loading: 'Loading galleries',
        dayGallery: 'Gallery of the Day',
        messageNoImages: 'This gallery has no images yet',
        deleteGallery: 'Delete gallery',
        stateAll: 'All',
        statePublish: 'Published',
        stateDraft: 'Draft',
        stateExpire: 'Offline',
        stateSchedule: 'Schedule',
        headerStatus: 'Status',
        headerKickerTitel: 'Kicker, Titel',
        headerBilder: 'Images',
        headerPreview: 'Preview',
        messageConfirmDayGallery1: 'Gallery',
        messageConfirmNotDayGallery2: 'is not selected as Gallery of the Day anymore',
        messageConfirmDayGallerySwitch2: 'is set as Gallery of the Day and the previous Gallery of the Day is unset',
        messageConfirmDayGallery2: 'is set as Gallery of the Day',
        messageDayUpdated: 'Gallery of the Day updated',
        messageDeletedConfirm1: 'Are you sure you want to delete gallery',
        messageDeletedConfirm2: '?',
        messageDeleted: 'Gallery deleted',
        dpEdit: 'Edit',
        dpDayGallery: 'Set as Gallery of the Day',
        dpDelete: 'Delete',
        multiSelect: 'Select',
        messageNoSelfLink: "Gallery can't link to itself.",
    },
    images: {
        backButton: 'Back to images list',
        title: 'Title',
        altText: 'Alt Text',
        altTextHint: 'If not filled, the title is used',
        caption: 'Caption',
        addImage: 'Add image',
        removeImage: 'Remove image',
        source: 'Source',
        publishedAt: 'Published at',
        expiredAt: 'Expired at',
        msn: 'MSN Service',
        deleteImage: 'Delete image',
        messageConfirmDelete1: 'Are you sure you want to delete image',
        messageConfirmDelete2: '?',
        messageMandatoryInformation: "You can't save this image because it is missing mandatory information",
        messageUpload: 'Image uploaded',
        messageSaved: 'Image saved',
        messageDeleted: 'Image deleted',
        invalid: 'Invalid',
        setFocalPoint: 'Please set the focal point by clicking on the image.*',
        articleLabel: 'Article',
        invalidVideoCover: 'Expired',
        invalidVideoCoverTooltip: 'This video has an expired image preview.',
        deletedVideoCover: 'Deleted',
        deletedVideoCoverTooltip: 'The image preview for this video has been deleted.',
        messageTooSmall: 'Image resolution is below minimal requirement of 1200x675 pixel. Please consider uploading bigger image.',
    },
    pingApi: {
        offline: 'You are offline - please check your internet connection.',
        backOnline: 'You are back online.',
        softUpdate: 'There is a new version of the editor with several improvements. To obtain the new functionalities, please reload the editor as soon as possible.',
        softUpdateCancel: 'Later',
        forceUpdate: 'There is a new version of the editor with important technical changes. To continue using the editor, please reload.',
        reload: 'Reload',
    },
    lockApi: {
        alreadyExists: 'Lock already exists',
        notFound: 'Lock not found',
        lockedByOtherUser: 'Locked by other user',
        lockedByOtherTab: 'Locked in by one of your other Browser Tab',
    },
    libApi: {
        pathArticleExists: 'An article with this path (SEO title) already exists',
        pathChannelExists: 'A channel with this path already exists',
        pathAuthorExists: 'An author with this path already exists',
        pathPageExists: 'A page with this path already exists',
        pathPersonExists: 'A person with this path already exists',
        pathUnique: 'The path is unique',
    },
    pagesApi: {
        notFound: 'Page not found',
        pathExists: 'Page with this path already exists',
        created: 'Page created',
        updated: 'Page updated',
    },
    customersApi: {
        notFound: 'Customer not found',
        updated: 'Customer updated',
        deleted: 'Customer deleted',
        resetEmailSent: 'Email to reset the password has been sent',
        emailNotFound: 'Email address not found',
    },
    toplinksApi: {
        notFound: 'Top link not found',
        created: 'Top link created',
        updated: 'Top link updated',
    },
    redirectsApi: {
        notFound: 'Redirect not found',
        created: 'Redirect created',
        updated: 'Redirect updated',
    },
    imagesApi: {
        notFound: 'Image not found',
    },
    pilotApi: {
        notFound: 'Placements not found',
        updated: 'Placements updated',
    },
    peopleApi: {
        notFound: 'Person not found',
        alreadyExists: 'Person with this name already exists',
        created: 'Person created',
        updated: 'Person updated',
        pathExists: "Person can't be updated because the path already exists",
    },
    videosApi: {
        notFound: 'Video not found',
    },
    whitelistApi: {
        created: 'Whitelist link created',
        deleted: 'Whitelist link deleted',
    },
    usersApi: {
        notAuthorized: 'Not authorized',
        noAccess: 'No access',
        noRightForAction: 'User has no right to perform this action',
        invalidApiToken: 'Token invalid',
        expiredApiToken: 'Expired token',
        signatureErrorApiToken: 'Invalid signature',
        invalidSessionToken: 'Session token invalid',
        notFound: 'User not found',
        notEnabled: 'User not enabled. Please open a ticket to get access.',
        twoFactorMissing: '2 factor authentication missing',
        unsupportedAuthenticationType: 'The authentication type specified in the request is not supported by the API',
    },
    videosList: {
        title: 'Videos',
        newButton: 'New videos',
        multi: 'Add selected videos',
        search: 'Search by title',
        status: 'State',
        dpAll: 'All',
        statusActive: 'Published on',
        statusInactive: 'Unpublished',
        statusSchedule: 'Scheduled on',
        date: 'Date',
        credits: 'Credits',
        uuid: 'Video UUID',
        noVideos: "Sorry, we couldn't find any videos mathing your search criteria",
        contentId: 'Xymatic ID',
    },
    linkWhitelist: {
        info: "Links to these domains won't be set as “nofollow”",
        newLink: 'New Link',
        url: 'Search URL',
        loading: 'Loading Link Whitelist',
        messageTitle: 'Delete whitelist link',
        messageMsg: 'Are you sure you want to delete this link?',
        newWLLink: 'New whitelist link',
        headerLink: 'Link',
        headerCreated: 'Created at',
        backButton: 'Back',
        title: 'Create Whitelist link',
        path: 'URL',
        actionButtonLabel: 'YES, REMOVE',
        cancelButtonLabel: 'Cancel',
    },
    pages: {
        backButton: 'Back',
        content: 'Content',
        preview: 'Preview',
        saveKeepPublished: 'Save & Keep published',
        savePublish: 'Save & publish',
        saveOffline: 'Save & take offline',
        saveDraft: 'Save as draft',
        unpublish: 'Take page offline',
        delete: 'Delete page',
        changeContent: 'Text format changed',
        changeContentMsg: 'The text format has been changed. This could remove content which is not supported in this format. Are you sure you want to save this page?',
        messageConfirmUnpublish1: 'Are you sure you that this page',
        messageConfirmUnpublish2: 'should be taken offline?',
        messageConfirmDelete2: 'should be deleted?',
        messageMandatoryInformation: "You can't save this page because mandatory information ismissing",
        messageCreated: 'Page created',
        messageUpdated: 'Page updated',
        messageDeleted: 'Page deleted',
    },
    pagesEdit: {
        title: 'Title',
        showTitle: 'Show title',
        styling: 'Use standard styling',
        author: 'Author',
        createdDate: 'Created at',
        changeDate: 'Changed at',
        path: '/',
        settings: 'Settings',
    },
    pagesList: {
        title: 'Pages',
        newButton: 'New Page',
        search: 'Name',
        status: 'Status',
        dpPublished: 'Published',
        dpPreview: 'Offline',
        loading: 'Loading pages',
        delete: 'Delete page',
        headerStatus: 'Status',
        headerTitle: 'Title',
        headerUrl: 'URL',
        dpEdit: 'Edit',
        dpDelete: 'Delete',
        noUrl: 'Page URL not found',
        messageConfirmDelete1: 'Are you sure you want to delete the page',
        messageConfirmDelete2: '?',
        messageDeleted: 'Page deleted',
    },
    customers: {
        backButton: 'Back to Customers list',
        id: 'Customer ID',
        email: 'Email',
        salutation: 'Salutation',
        firstname: 'First name',
        lastname: 'Last name',
        birth: 'Birth date',
        street: 'Street',
        streetNr: 'House number',
        postcode: 'Postcode',
        city: 'City',
        country: 'Country',
        resetPW: 'Reset password',
        resetPWHint: 'New password will be sent to the customer',
        createdAt: 'Created at',
        confirmedAt: 'Confirmed at',
        lastLogin: 'Last login',
        lastChange: 'Last change',
        phone: 'Phone',
        subscriptionId: 'Subscription ID',
        subscriptionStatus: 'Subscription status',
        subscriptionCreated: 'Subscription created',
        subscriptionNextBilling: 'Next subscription billing',
        mr: 'Mr',
        mrs: 'Mrs',
        de: 'Germany',
        at: 'Austria',
        ch: 'Switzerland',
        availableHearts: 'Available hearts',
        redeemedHearts: 'Redeemed hearts',
        totalHearts: 'Total hearts',
        lVideo: 'Video',
        lArticle: 'Article',
        lRegister: 'Registration',
        lShare: 'Share',
        lSpecial: 'Special',
        lNewsletter: 'Newsletter',
        lSurvey: 'Survey',
        messageMandatoryInformation: "You can't save the customer because it is missing mandatory information",
        messageUpdated: 'Customer updated',
        messageResetPw: 'Link to reset password sent',
    },
    customersList: {
        title: 'Customers list',
        search: 'Search customer',
        createdRange: 'Creation period',
        status: 'Customer status',
        statusRegistered: 'Registered',
        statusConfirmed: 'Confirmed',
        lastLoginRange: 'Last login period',
        subStatus: 'Subscription status',
        none: 'None',
        active: 'Active',
        trial: 'Trial',
        nonRenew: 'In review',
        cancelled: 'Cancelled',
        loading: 'Loading customers',
        delete: 'Delete customer',
        headerFName: 'First name',
        headerLName: 'Last name',
        headerEmail: 'Email',
        headerCreatedAt: 'Created at',
        headerLastLogin: 'Last login',
        headerSubStatus: 'Subscription status',
        headerStatus: 'Customer status',
        headerHearts: 'Available hearts',
        messageDelete: 'Are you sure you want to delete the customer?',
        messageDeleted: 'Customer deleted',
        dpEdit: 'Edit',
        dpDelete: 'Delete',
        cannotDelete: "You can't delete a customer with an active subscription",
    },
    homeTopBar: {
        aPlacement: 'Article placement',
        aPlaced1: 'Artice is already placed on',
        aPlaced2: '',
        hMainTitle: 'Main Stage (Home)',
        hTBTitle: 'Top Bar (Meistgelesen)',
        hSavePublish: 'Save & Publish',
        hAlreadyMainStage: 'Article is already placed on Main Stage (Home)',
        hAlreadyTopBar: 'Article is already placed on Top Bar (Meistgelesen)',
        hMainMin: 'Main Stage (Home) must contain at least 4 articles',
        hMainMax: "Main Stage (Home) can't contain more than 5 articles",
        hTB5: 'Top Bar (Meistgelesen) must contain 5 articles',
        hMessageUpdated: 'Placements updated',
        qSearch: 'Search',
        qNoResults: 'No results found',
        title: 'You have unsaved changes',
        message: 'Do you want to discard all changes ? ',
    },
    redirectsList: {
        title: 'Redirects',
        newButton: 'New redirect',
        search: 'Search redirects',
        loading: 'Loading redirects',
        delete: 'Delete redirects',
        headerFrom: 'From',
        headerTo: 'To',
        messageDelete: 'Are you sure you want to delete this redirect?',
        messageDeleted: 'Redirect deleted',
        dpEdit: 'Edit',
        dpDelete: 'Delete',
    },
    redirects: {
        basics: 'Create',
        backButton: 'Back',
        from: 'From',
        to: 'To',
        messageMandatoryInformation: "You can't save because mandatory information is missing",
        messageUpdated: 'Redirect updated',
        messageCreated: 'Redirect created',
        btnMessageCancel: 'Cancel',
        btnMessageConfirm: 'Yes, Remove',
    },
    topLinksList: {
        title: 'Toplinks',
        newButton: 'New Toplink',
        loading: 'Loading Toplinks',
        delete: 'Delete link',
        headerName: 'Name',
        headerPath: 'Path',
        messageDelete1: 'Are you sure you want to delete the link',
        messageDelete2: '?',
        messageDeleted: 'Link deleted',
        dpEdit: 'Edit',
        dpDelete: 'Delete',
    },
    topLinks: {
        backButton: 'Back',
        name: 'Name',
        path: 'Path',
        messageMandatoryInformation: "You can't save the toplink because mandatory information is missing",
        messageUpdated: 'Toplink updated',
        messageCreated1: 'Toplink',
        messageCreated2: 'created',
        basics: 'Create TopLink',
        actionButtonLabel: 'YES, REMOVE',
        cancelButtonLabel: 'Cancel',
    },
    resetPW: {
        select: 'Select password',
        '2faCode': '2 factor authentication',
        '2faDesc': 'Please scan this QR-Code with your Microsoft or Google Authenticator app. After that, you need to enter a second code on login.',
        '2fa': '2 factor token',
        continue: 'Continue',
        messageNoChangeTitle: 'The link has expired.',
        messageNoChange: "You can't change the password. Please request a new password via the reset link.",
        match: 'Passwords must match',
    },
    peopleList: {
        title: 'People',
        newButton: 'New person',
        search: 'Search by name',
        ranking: 'Ranking',
        loading: 'Loading People',
        headerName: 'Name',
        headerBirth: 'Birth date',
        headerPicture: 'Image',
        headerSimilar: 'Related People',
        dpEdit: 'Edit',
        dpShow: 'Show',
        multiLabel: 'Select people',
        multiSelect: 'Select',
    },
    people: {
        name: 'Display name',
        firstName: 'First name',
        lastName: 'Last name',
        male: 'male',
        female: 'female',
        zodiacSign: 'Zodiac sign',
        birth: 'Birth date',
        dateDeath: 'Date of death',
        placeBirth: 'Birth place',
        size: 'Size (cm)',
        bioShort: 'Short biography',
        bio: 'Biography',
        picture: 'Select or upload main image',
        ranking: 'Ranking',
        messageMandatoryInformation: "You can't save the person because mandatory information is missing",
        messageUpdated: 'Person updated',
        messageCreated: 'Person created',
        aries: 'Aries',
        taurus: 'Taurus',
        gemini: 'Gemini',
        cancer: 'Cancer',
        leo: 'Leo',
        virgo: 'Virgo',
        libra: 'Libra',
        scorpio: 'Scorpio',
        sagittarius: 'Sagittarius',
        capricorn: 'Capricorn',
        aquarius: 'Aquarius',
        pisces: 'Pisces',
        userRole: 'User role',
        relatedPeople: 'Related People',
        settings: 'Settings',
    },
    video: {
        channel: 'Channel',
        published: 'Published',
        liveFrom: 'Live since',
        expiredAt: 'Expires on',
        title: 'Video',
        search: 'Search by name or kicker',
        contentId: 'Xymatic ID',
        mode: 'video status',
        all: 'All',
        unpublished: 'Offline',
        uuid: 'Video UUID',
        premium: 'Inside video',
        noVideo: "We couldn't find any video matching your search criteria",
        providers: 'Providers',
    },
    locks: {
        lockedBy: 'Content is locked by:',
        break: 'Break lock',
        lockedByYou: 'The content is locked by yourself in another tab',
        lockRemoved: 'Lock was removed',
        contentChanged: "The content was updated externally. Your content can't be saved in this tab anymore.",
        refresh: 'Refresh',
    },
    validation: {
        required: 'required',
        minLength1: 'Must contain at least',
        minLength2: 'characters',
        maxLength1: 'Must not exceed',
        maxLength2: 'characters',
        exactLengthNumber1: 'Please enter exactly',
        exactLengthNumber2: 'numbers',
        containNumber: 'Must contain a number',
        containLowercase: 'Must contain a lowercase letter',
        containUppercase: 'Must contain an uppercase letter',
        validEmail: "Must be a valid email address (e.g.: test{'@'}test.test)",
        validPath: "Must be a valid URL (e.g.: /valid-url) and can't contain special characters",
        validDate: 'Must be in valid date format: dd.mm.yyyy (e.g.: 14.04.2006)',
        validDateTime: 'Must be in valid date/time format: dd.mm.yyyy hh:mm (e.g.: 14.04.2006 15:03)',
        validDateNotInFuture: 'Date must not be in the future',
        notContainHTML: 'Should not contain ".html"',
        isNumeric: 'Must be numeric',
        isRelativePath: 'Path must begin with /',
        lessThan11: 'Must be a number between 0 and 10',
        lessThanNumber: 'Must be a number between 0 and {number}',
        validURL: 'Must be a valid link',
        higherEqual0: 'Must be a number higher or equal to 0',
        validBrandUrl: 'Must be a valid {brand} URL',
        exactNumber: 'Must be exact {number}',
        evenNumber: 'Must be an even number',
        multipleOfNumber: 'Must be a multiple of {number}',
        moreThan: 'Must be equal to or more than {number}',
        lessThan: 'Must be equal to or less than {number}',
        validPublishState: 'Must be a valid publish state',
    },
    listView: {
        filterDelete: 'Remove filters',
        filter: 'Filters',
        more: 'More',
        less: 'Less',
    },
    blockLabel: {
        login: 'Login',
        main: 'Main channel stage',
        subchannel: 'Channel stage',
        video: 'Video stage',
        custom: 'Script',
        topbar: 'Topbar/Meistgelesen',
        fixed: 'Fixed article',
        flex: 'Auto article',
        teaser: 'Linkout teaser',
        fixedVideo: 'Fixed video',
        performerVideo: 'Performance video',
        latestVideo: 'Latest video',
        gallery: 'Gallery',
        newsletter: 'Newsletter box',
        dayGallery: 'Gallery of the day',
        newsticker: 'Newsticker',
        mainStage: 'Main Stage',
        starlook: 'Starlook',
        more: 'Background articles',
        channelTopbar: 'Channel Topbar',
        homepage: 'Homepage Block',
    },
    components: {
        articleSource: 'Article source',
        channelSelectorLabel: 'Channel',
        personSelectorLabel: 'Related People',
        bfJob: 'BF team',
        contentPartner: 'Content partner',
        noPartner: 'No partner',
        gTopNews: 'TOP NEWS',
        gDiscover: 'DISCOVER',
        hourAgo: '1 hour ago',
        bunteHour: 'Bunte 1 hour',
        gNewsSearch: 'NEWS SEARCH',
        urlSettings: 'URL Settings',
        gNewsApp: 'NEWS APP',
        yesterday: 'Yesterday',
        articleSwitch: 'Switch article',
        articleSelect: 'Select article',
        authorSelect: 'Select author',
        authorInactive: 'Inactive',
        articleInvalid: 'Article is invalid',
        previewMobile: 'Mobile',
        previewTablet: 'Tablet',
        previewDesktop: 'Desktop',
        previewAMP: 'AMP',
        previewApp: 'App',
        previewGoogle: 'Google',
        previewPageInvalid: 'Page invalid',
        previewArticleInvalid: 'Article invalid',
        block: 'Block',
        reactivate: 'Reactivate',
        useAsDayGallery: 'Use as Gallery of the day',
        notUseAsDayGallery: "Don't use as Gallery of the day",
        imageUploadLabel: 'Select or upload a main image. {maxFileSize}MB limit',
        imageSelectorHintInvalid: 'Invalid image',
        imageSelectorHintUnknown: 'Unknown error',
        uploadImage: 'Upload Image',
        editImage: 'Edit Image',
        selectVideo: 'Select Video',
        selectGallery: 'Select Gallery',
        fieldRequired: 'This field is required',
        selectUploadImage: 'Select or upload image',
        newsletterKind: 'Type of newsletter',
        password: 'Password',
        blockRemoveTitle: 'Remove block',
        blockRemoveDescription: 'Are you sure you want to remove this block?',
        low: 'Low',
        medium: 'Medium',
        high: 'High',
        date: 'Date',
        time: 'Time',
        fullHTML: 'Switch to full HTML',
        noRichTextEditor: 'The rich text editor is not available because the content contains tags (e.g. "script") that it does not support. Switching to the editor anyway may result in data loss.',
        useAnyway: 'Use rich text editor anyway',
        fullHTMLScriptCode: 'Enter full HTML or script code',
        people: 'People',
        articles: 'Articles',
        channels: 'Channels',
        noFollow: 'Nofollow',
        markAffiliate: 'Mark as affiliate',
        newTab: 'Open in new tab',
        paragraph: 'Paragraph',
        heading2: 'Heading 2',
        heading3: 'Heading 3',
        imageSelect: 'Select image',
        imageSelected: 'Selected',
        imageExpiresIn: 'Expires in {n} days',
        imageExpired: 'Expired',
        imageExpires: 'Expires',
        imagePublish: 'Online in {n} days',
        imageCreated: 'Created',
        imageTitle: 'Title',
        imageCredits: 'Credits',
        imageStatus: 'Status',
        aspectText: 'Preview for different image sizes based on the focal point',
        aspectTeaser: 'Teaser Home & Channel + Title Image Mobile',
        aspectTitle: 'Title image on Tablet & Desktop',
        aspectDesc: 'After setting the focal point, the preview is visible here after saving.',
        aspectClick: 'Please focus on the square image',
        videoPreviewPlay: 'Video preview',
        videoPreviewClose: 'Close video preview',
        imageDeleted: 'Deleted',
    },
    newsletter: {
        inside: 'Wöchentlich die besten BUNTE inside Themen per E-Mail',
        portal: 'Die beliebtesten News des Tages per E-Mail',
        royals: 'Der wöchentliche Newsletter aus der Adelsredaktion',
        family: 'Wöchentliche Tipps für alle Lebenslagen per E-Mail',
        health: 'Deine wöchentlichen News für ein gesundes Leben',
        deals: 'Die besten BUNTE.de Deals der Woche',
        aktionen: 'Exklusive Angebote, Gewinnspiele, Gutscheine und Stories nur für dich',
    },
};
//# sourceMappingURL=en.js.map